import {useEffect, useRef} from 'react';
import {usePutPopupMessage} from '../../core/repositories/usersMeRepository';

// 既読の送信に失敗したときの試行回数の上限。失敗のたびに送り直して
// ループするのを避けるために区切る
const MARK_AS_SHOWN_MAX_ATTEMPTS = 3;

type Args = {
  opened: boolean;
  messageType: string;
};

/**
 * ポップアップを表示した時点で既読にする。
 * 閉じるまで待つとWebとアプリで二重に出るため。
 */
export const useMarkPromptAsShown = ({opened, messageType}: Args) => {
  const hasMarkedAsShown = useRef(false);
  const markAsShownAttempts = useRef(0);

  const markAsShown = usePutPopupMessage({
    onSuccessFnc() {},
    onErrorFnc() {},
  });

  useEffect(() => {
    if (
      !opened ||
      hasMarkedAsShown.current ||
      markAsShown.isLoading ||
      markAsShownAttempts.current >= MARK_AS_SHOWN_MAX_ATTEMPTS
    ) {
      return;
    }
    markAsShownAttempts.current += 1;
    markAsShown.mutate(messageType, {
      onSuccess() {
        hasMarkedAsShown.current = true;
      },
    });
  }, [opened, messageType, markAsShown]);
};
